export default async function copyText(text: string): Promise<void> {
  const textarea = document.createElement('textarea');
  const previousFocus = document.activeElement;
  textarea.value = text;
  textarea.readOnly = true;
  textarea.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
  document.body.appendChild(textarea);

  try {
    textarea.focus({ preventScroll: true });
    textarea.select();
    // Keep copying in the click gesture for browsers with restricted Clipboard API access.
    if (document.execCommand('copy')) return;
  } catch {
    // Use the Clipboard API when the browser does not support the synchronous copy command.
  } finally {
    textarea.remove();
    if (previousFocus instanceof HTMLElement) previousFocus.focus({ preventScroll: true });
  }

  await navigator.clipboard.writeText(text);
}
